import { CommonFilterEnum, ElasticsearchFilterTypeEnum } from '@lyearn-team/reporting-library';

export default async function getContentByIds(reportingLibrary, contentIds) {
  const response = await reportingLibrary.getContentsByIds([
    {
      type: ElasticsearchFilterTypeEnum.MUST,
      name: CommonFilterEnum.ID,
      values: contentIds
    }
  ]);
  return response.contents[0];
}
